<template>
    <ml-layout title="实践教学管理平台" :nav="nav">
        <div class="ml-main">
            <div class="title">{{ title }}</div>
            <div class="date">{{ date }}</div>
            <div class="content" v-html="content"></div>
        </div>
    </ml-layout>
</template>

<script>
import { getArticleInfo } from "@/api/views/lab";
import { getFontendFolderList } from "@/api/views/lab";

import MlLayout from "@/components/MlLayout";

export default {
    name: "Home",
    components: {
        MlLayout
    },
    data() {
        return {
            nav: [{ title: "首页", path: ["/lab"] }],
            title: null,
            date: null,
            content: null
        };
    },
    created() {
        getFontendFolderList({
            center_id: process.env.VUE_APP_CENTER2_ID
        }).then(res => {
            res.folderList.forEach(item => {
                this.nav.push({
                    title: item.name,
                    path: ["/labPage?id=" + item.children[0].id]
                });
            });
        });
        getArticleInfo({
            id: this.$route.query.id
        }).then(res => {
            this.title = res.data.title;
            this.date = res.data.addtime;
            this.content = res.data.content;
        });
    }
};
</script>

<style scoped>
.ml-main {
    margin-top: 20px;
    background-color: #fff;
}

.title {
    text-align: center;
    font-size: 24px;
}

.date {
    float: right;
    margin-right: 20px;
}

.content {
    padding: 20px;
}
</style>
